import { useCallback, useMemo } from 'react';

const useStayLength = ({ dispatch, value, stayLengthData }) => {
  const onChange = useCallback(
    ({ value }) => {
      const tracking = stayLengthData.find(
        (item) =>
          JSON.stringify(item.value) === (typeof value === 'string' ? value : JSON.stringify(value))
      );
      dispatch({
        type: 'STAY_LENGTH_CHANGE',
        payload: {
          value: typeof value === 'string' ? JSON.parse(value) : value,
          valueTracking: tracking?.valueTracking ?? ''
        }
      });
    },
    [dispatch, stayLengthData]
  );

  const onClear = (payload) => {
    dispatch({
      type: 'STAY_LENGTH_CLEAR',
      payload
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => ({ value, onChange, onClear }), [value, onChange]);
};

export default useStayLength;
